import React from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import FormTexts from "../../../../constants/forms";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import loginIcon from "../../../../assets/images/svg/login_user_icon.svg";
import { formsPlaceHolderType, formsButtonType } from "../../../../enums/index";
const LoginForm = (props) => {
  return (
    <Form onSubmit={(e) => props.handleLogin(e)} className="login-form">
      {!props.showSpinner && <img src={loginIcon} alt="login icon" />}
      {props.showSpinner && <FontAwesomeIcon icon={faSpinner} spin />}
      <Form.Group className="mb-3">
        <Form.Control
          onChange={(e) => props.handleChangeEmail(e)}
          type="email"
          className={`${
            props.errorValidationMSG.email ? "validation-error" : "normal-input"
          }`}
          placeholder={FormTexts.PlaceHolders(formsPlaceHolderType.Email())}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Control
          onChange={(e) => props.handleChangePassword(e)}
          className={`${
            props.errorValidationMSG.password
              ? "validation-error"
              : "normal-input"
          }`}
          type="password"
          placeholder={FormTexts.PlaceHolders(formsPlaceHolderType.Password())}
        />
      </Form.Group>
      {props.errorValidation && (
        <>
          <p className="validation-error">{props.errorValidationMSG.email}</p>
          <p className="validation-error">
            {props.errorValidationMSG.password}
          </p>
        </>
      )}
      <Button
        type="submit"
        disabled={props.disableButton}
        onClick={(e) => props.handleLogin(e)}
      >
        {FormTexts.Buttons(formsButtonType.Enter())}
      </Button>
    </Form>
  );
};
export default LoginForm;
